var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "v-icon__svg",
      attrs: { width: "24px", height: "24px", viewBox: "0 0 24 24" },
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "pose-silhouette",
            transform: "translate(3.000000, 3.000000)",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M16.7274066,3.92944764 C16.8703484,4.46291374 16.5537659,5.0112507 16.0202998,5.15419251 L10.9407634,6.51489418 C10.9794597,6.6702091 11,6.83270582 11,7 L11.0009085,10.6757226 C11.1067114,10.723966 11.2058319,10.7916183 11.2928932,10.8786797 L14.1213203,13.7071068 C14.3382783,13.9240647 14.434704,14.2159118 14.4105976,14.4994378 C14.4349321,14.7833974 14.338535,15.0756785 14.1213203,15.2928932 L11.2928932,18.1213203 C10.9023689,18.5118446 10.2692039,18.5118446 9.87867966,18.1213203 C9.48815536,17.7307961 9.48815536,17.0976311 9.87867966,16.7071068 L12.0857864,14.5 L10.1918366,12.6062459 C9.85898204,12.8536298 9.44658432,13 9,13 C8.77759846,13 8.56367554,12.9636988 8.36383321,12.8966983 C8.31792579,13.0410634 8.23665375,13.1775598 8.12132034,13.2928932 L5.29289322,16.1213203 C5.07593528,16.3382783 4.78408824,16.434704 4.50056221,16.4105976 C4.21660263,16.4349321 3.92432148,16.338535 3.70710678,16.1213203 L0.878679656,13.2928932 C0.488155365,12.9023689 0.488155365,12.2692039 0.878679656,11.8786797 C1.26920395,11.4881554 1.90236893,11.4881554 2.29289322,11.8786797 L4.49978644,14.085 L6.70710678,11.8786797 C6.82244019,11.7633462 6.95893663,11.6820742 7.10409595,11.6348636 C7.03642274,11.4370399 7,11.2227734 7,11 L6.99978644,7.571 L2.49733826,8.77765914 C1.96387216,8.92060095 1.4155352,8.60401846 1.27259339,8.07055236 C1.12965158,7.53708626 1.44623407,6.9887493 1.97970017,6.84580749 L15.5026617,3.22234086 C16.0361278,3.07939905 16.5844648,3.39598154 16.7274066,3.92944764 Z M9,0 C10.1045695,0 11,0.8954305 11,2 C11,3.1045695 10.1045695,4 9,4 C7.8954305,4 7,3.1045695 7,2 C7,0.8954305 7.8954305,0 9,0 Z",
              id: "pose",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }